type Props = {
  id?: string;
  value: string; // "HH:MM"
  onChange: (next: string) => void;
  className?: string;
  ariaLabel?: string;
  label?: string;
};

/**
 * Native time picker. Opens the OS clock (with the current time)
 * on mobile and a normal time field on desktop.
 */
export function TimeInput({ id, value, onChange, className, ariaLabel, label }: Props) {
  return (
    <div className="flex flex-1 flex-col gap-1">
      {label ? (
        <label htmlFor={id} className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
          {label}
        </label>
      ) : null}
      <input
        id={id}
        type="time"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
        className={`w-full appearance-none rounded-xl border border-border bg-background px-3 py-2.5 text-base font-medium text-foreground outline-none transition focus:border-brand ${className ?? ""}`}
      />
    </div>
  );
}
